import type { Events } from '@setplex/pureya'
import type { SendEventParams } from '~/shared/analytix'
import type { PlayerOpenParameters } from './player-open'

import { createWatch } from 'effector'
import { SnapshotMap } from '../../general/snapshot-map'
import { stripHashFromUrl, truncateManifest } from '../lib'
import { manifestDownloaded } from '../models/cdn-info'
import { parameters as playerOpenParameters } from './player-open'

const SNAPSHOTS_TO_KEEP = 5

export type CdnInfoParameters = SendEventParams.CDNInfo & {
  '(playerId)'?: string[] // auxiliary parameter to store players id for internal use, it will not be sent to analytix
}

/**
 * SnapshotMap to store `cdn_info` event parameters with their history
 */
export const parameters = new SnapshotMap<CdnInfoParameters>(SNAPSHOTS_TO_KEEP)

//
// Update parameters
//

function fromPlayerOpenParameters(params: SnapshotMap<PlayerOpenParameters>) {
  parameters
    .update('(playerId)', params.get('(playerId)'))
    .update('contentId', params.get('contentId'))
    .update('contentType', params.get('contentType'))
    .commit()
    .notify()
}

function fromMasterManifestData(
  payload: Events.Media.MasterManifestDownloaded
) {
  parameters
    .update('manifest', truncateManifest(payload.manifest))
    .update('cdnLatency', payload.latency ? String(payload.latency) : undefined)
    .update('cdnUrl', stripHashFromUrl(payload.url))
    .commit()
    .notify()
}

//
// Updates listeners
//

// on player open parameters update
playerOpenParameters.updates.on(() => {
  fromPlayerOpenParameters(playerOpenParameters)
})

// on master manifest data
createWatch({
  unit: manifestDownloaded,
  fn({ payload }) {
    fromMasterManifestData(payload)
  },
})
